import CompareIcon from '@mui/icons-material/Compare'
import { Box, Pagination, Stack, Typography } from '@mui/material'
import { useState } from 'react'
import API_URLS from '../../backend/ApiUrls'
import FlowApiClient from '../../backend/sub_api_clients/FlowApiClient'
import { IPagination, IPaginationQueryResponse } from '../../definitions/Common'
import { IFlow } from '../../definitions/Nodes'
import { ISimpleExecutionEnvironment } from '../../definitions/NodesExecution'
import Formatter from '../../helpers/Formatter'
import SmartCard from '../controls/cards/SmartCard'
import { Cell, Column, SmartTable } from '../controls/table'
import useQuery, { buildQueryKey } from '../hooks/useQuery'
import { FlowEditorMode } from './SettlementFlowEditor'

interface P {
    flow: IFlow
    setComparedExecEnv: (comparedEE?: ISimpleExecutionEnvironment) => void
    setEditorMode: (editorMode: FlowEditorMode) => void
    onClose: () => void
}

const ListExeEnvs = ({ flow, setComparedExecEnv, setEditorMode, onClose }: P) => {
    const [pagination, setPagination] = useState<IPagination>({ page: 0, batch: 10, lastKey: null })

    const { status: execEnvsStatus, response: execEnvs } = useQuery<IPaginationQueryResponse<ISimpleExecutionEnvironment>>({
        queryKey: buildQueryKey(API_URLS.settlement.getFlowExecutionEnvironments, flow.uuid, pagination.page, pagination.batch),
        queryFn: async () => FlowApiClient.getFlowExecutionEnvironments(flow.uuid, pagination),
        cache: true
    })

    const handlePageChange = (event, newPage: number) => {
        setPagination(prev => ({ ...prev, page: newPage - 1 }))
    }

    const columns: Column<ISimpleExecutionEnvironment>[] = [
        {
            id: 'startedAt', label: 'Date', isPK: true, customRenderer: (cell: Cell) => {
                return <Typography>{cell.value ? Formatter.date(new Date(cell.value), 'mm/dd/yyyy hh:mm:ss') : ''}</Typography>
            }
        },
        { id: 'mode', label: 'Mode' },
        { id: 'flow.versioning.version', label: 'Versioning', customRenderer: (cell: Cell) => {
            return <Typography>v{cell.value}</Typography>
        } }
    ]

    return (
        <Stack padding={2} height='100%' spacing={2}>
            <Stack flexDirection='row' alignItems='center'>
                <CompareIcon fontSize='large' color='action' />
                <Typography marginLeft={1}>Select the row to compare</Typography>

            </Stack>
            <SmartCard sx={{ flex: 1, display: 'flex', flexDirection: 'column', height: '100%', overflow: 'auto', padding: 1 }}>
                <SmartTable<ISimpleExecutionEnvironment>
                    columns={columns}
                    noCollapse
                    sticky
                    onClickRow={(indexRow, cells, row, item) => {
                        setEditorMode('compare')
                        setComparedExecEnv(item)
                        onClose()
                    }}
                    datasource={{
                        items: execEnvs?.queryResponse ?? []
                    }}
                    toolbar={{
                        columns: true,
                        search: ['startedAt'],
                        filters: true
                    }}
                    sx={{ marginTop: 1, padding: 1 }}
                    isLoading={execEnvsStatus === 'loading'}
                />
            </SmartCard>
            <Box display='flex' justifyContent='flex-end' mt={2}>
                <Pagination
                    count={Math.ceil((execEnvs?.totalItems ?? 1) / pagination.batch)}
                    page={pagination.page + 1}
                    onChange={handlePageChange}
                    color='primary'
                />
            </Box>
        </Stack>
    )
}

export default ListExeEnvs
